var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg45(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    height: "48px",
    width: "48px",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.45,12.98h-3.37c-1.08,0-1.95-0.87-1.95-1.95v-8.2c0-1.08,0.87-1.95,1.95-1.95h3.37 c1.08,0,1.95,0.87,1.95,1.95v8.2C15.4,12.11,14.53,12.98,13.45,12.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M39.42,12.98h-3.37c-1.08,0-1.95-0.87-1.95-1.95v-8.2c0-1.08,0.87-1.95,1.95-1.95h3.37 c1.08,0,1.95,0.87,1.95,1.95v8.2C41.37,12.11,40.5,12.98,39.42,12.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.45,45.45h-3.37c-1.08,0-1.95-0.87-1.95-1.95v-8.2c0-1.08,0.87-1.95,1.95-1.95h3.37 c1.08,0,1.95,0.87,1.95,1.95v8.2C15.4,44.57,14.53,45.45,13.45,45.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M39.42,45.45h-3.37c-1.08,0-1.95-0.87-1.95-1.95v-8.2c0-1.08,0.87-1.95,1.95-1.95h3.37 c1.08,0,1.95,0.87,1.95,1.95v8.2C41.37,44.57,40.5,45.45,39.42,45.45z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.77,
    y: 5.31,
    fill: "currentColor",
    width: 25.97,
    height: 3.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.77,
    y: 37.78,
    fill: "currentColor",
    width: 25.97,
    height: 3.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.13,
    y: 6.94,
    fill: "currentColor",
    width: 3.25,
    height: 32.46
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M32.18,32.55l-0.57-0.57c-0.63-0.63-1.65-0.63-2.28,0l-3.43,3.43c-0.63,0.63-1.65,0.63-2.28,0l-3.43-3.43 c-0.63-0.63-1.65-0.63-2.28,0l-0.57,0.57c-0.63,0.63-0.63,1.65,0,2.28l3.43,3.43c0.63,0.63,0.63,1.65,0,2.28l-3.43,3.43 c-0.63,0.63-0.63,1.65,0,2.28l0.57,0.57c0.63,0.63,1.65,0.63,2.28,0l3.43-3.43c0.63-0.63,1.65-0.63,2.28,0l3.43,3.43 c0.63,0.63,1.65,0.63,2.28,0l0.57-0.57c0.63-0.63,0.63-1.65,0-2.28l-3.43-3.43c-0.63-0.63-0.63-1.65,0-2.28l3.43-3.43 C32.81,34.2,32.81,33.18,32.18,32.55z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg45);
export default __webpack_public_path__ + "static/media/45.d13f84f79f3fbaae51d9fa40380aef6d.svg";
export { ForwardRef as ReactComponent };